var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 0.199951C1.97395 0.199951 0 2.03886 0 4.29832C0 5.37434 0.503525 6.80529 1.49655 8.55151C2.29405 9.95353 3.21667 11.2213 3.69655 11.8522C3.77764 11.96 3.88366 12.0476 4.00602 12.108C4.12838 12.1685 4.26364 12.2 4.40083 12.2C4.53801 12.2 4.67327 12.1685 4.79563 12.108C4.91799 12.0476 5.02401 11.96 5.1051 11.8522C5.58415 11.2213 6.5076 9.95353 7.3051 8.55151C8.29648 6.80582 8.8 5.37488 8.8 4.29832C8.8 2.03886 6.82605 0.199951 4.4 0.199951ZM4.4 6.20018C4.0519 6.20018 3.71163 6.09963 3.4222 5.91126C3.13277 5.72288 2.90718 5.45514 2.77397 5.14188C2.64076 4.82862 2.60591 4.48392 2.67382 4.15137C2.74173 3.81882 2.90935 3.51335 3.15549 3.2736C3.40163 3.03384 3.71523 2.87056 4.05664 2.80442C4.39805 2.73827 4.75192 2.77222 5.07352 2.90197C5.39512 3.03173 5.67 3.25146 5.86339 3.53338C6.05678 3.81531 6.16 4.14676 6.16 4.48583C6.15949 4.94035 5.9739 5.37611 5.64395 5.69751C5.31399 6.0189 4.86662 6.19968 4.4 6.20018Z",
    fill: "#FF8604"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.292e19a6e0346e833086f32f0b1bd96d.svg";